import React from 'react';
import { PenTool, Ruler, Scissors, PackageCheck } from 'lucide-react';

const STEPS = [
  { icon: PenTool, t: 'Choose Your Design', d: 'Pick any HITÉRA piece or share your inspiration with us.' },
  { icon: Ruler, t: 'Share Measurements', d: 'Send your measurements on WhatsApp — we tailor to your exact fit.' },
  { icon: Scissors, t: 'Crafted In 2–3 Weeks', d: 'Our karigars hand-craft your outfit over the next 2 to 3 weeks.' },
  { icon: PackageCheck, t: 'Delivered To You', d: 'Your bespoke creation is carefully packed and delivered to your door.' },
];

export default function CustomOrderStrip() {
  return (
    <section className="bg-burgundy-950 text-cream py-16 md:py-20" data-testid="custom-order-strip">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center">
        <p className="text-gold tracking-luxe text-xs uppercase mb-4">Made Just For You</p>
        <h2 className="font-display text-4xl md:text-5xl mb-4">How Custom Orders Work</h2>
        <p className="text-cream/60 max-w-xl mx-auto mb-14 text-sm leading-relaxed">
          Every HITÉRA piece is custom-made to your measurements and delivered within 2–3 weeks.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {STEPS.map((s, i) => (
            <div key={s.t} className="relative flex flex-col items-center fade-up" style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="w-16 h-16 rounded-full border border-gold/40 flex items-center justify-center mb-5 relative">
                <s.icon size={24} className="text-gold" strokeWidth={1.6} />
                <span className="absolute -top-2 -right-1 text-gold/50 font-display text-lg">{i + 1}</span>
              </div>
              <h3 className="text-base md:text-lg text-cream mb-2">{s.t}</h3>
              <p className="text-cream/55 text-sm leading-relaxed max-w-[220px]">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
